import { useState } from 'react';
import type { ScreenProps } from '../../app/types';
import { createDomain } from '../../domain/farm';
import { ageStr } from '../../domain/dates';
import { ActionButton, Card, PrintBadge, ScrollTable } from '../../components/ui';
import { EntityLink } from '../../components/EntityLink';
import SowDetail from './SowDetail';
import SowMap from './SowMap';

export default function SowScreen(props: ScreenProps & { selectedId?: string }) {
  const { state, selectedId, openForm, navigate, canEdit } = props;
  const [view, setView] = useState<'lista' | 'mapa'>('lista');
  const [filter, setFilter] = useState('');
  const domain = createDomain(state);
  const sow = state.cerdas.find(record => record.arete === selectedId);
  if (sow) return <SowDetail {...props} sow={sow} />;
  const list = state.cerdas.filter(record => record.arete.toLocaleLowerCase().includes(filter.toLocaleLowerCase()));
  return <>
    <div className="section-toolbar">
      <div className="tabs-sub" aria-label="Vista de cerdas">
        <button type="button" className={view === 'lista' ? 'active' : ''} aria-pressed={view === 'lista'} onClick={() => setView('lista')}>Listado</button>
        <button type="button" className={view === 'mapa' ? 'active' : ''} aria-pressed={view === 'mapa'} onClick={() => setView('mapa')}>Mapa físico</button>
      </div>
      <ActionButton variant="wheat" disabled={!canEdit} onClick={() => openForm('formNuevaCerda')}>🐷 Nueva cerda</ActionButton>
    </div>
    {selectedId && <div role="status" className="muted">La cerda seleccionada ya no está disponible.</div>}
    {view === 'mapa' ? <SowMap {...props} /> : <Card>
      <div className="search-box"><input aria-label="Buscar por arete" placeholder="Buscar por arete…" value={filter} onChange={event => setFilter(event.target.value)} /></div>
      {!list.length ? <div className="empty-state"><span className="emoji">🐷</span>{filter ? 'No hay cerdas que coincidan con la búsqueda.' : 'Sin cerdas registradas.'}</div> : <ScrollTable label="Listado de cerdas">
        <thead><tr><th scope="col">Arete</th><th scope="col">Raza</th><th scope="col">Edad</th><th scope="col">Estado</th><th scope="col">Partos</th></tr></thead>
        <tbody>{list.map(record => <tr key={record.arete}>
          <td>{domain.cerdaEnObservacion(record) && <span title={`En observación${record.motivoObservacion ? `: ${record.motivoObservacion}` : ''}`} aria-label="En observación">👁️ </span>}
            <EntityLink state={state} navigate={navigate} reference={{ type: 'cerda', id: record.arete }}><b>{record.arete}</b></EntityLink>{' '}<PrintBadge record={record} /></td>
          <td>{record.raza || '—'}</td><td>{ageStr(record.fechaNacimiento)}</td>
          <td><span className={`badge ${domain.estadoCerdaClase(record.estado)}`}>{record.estado}</span>{domain.avisoEstadoCerda(record) && <span className="status-pill" title={domain.avisoEstadoCerda(record)}>⚠️ Revisar</span>}{domain.avisoRepeticiones(record.arete) && <span className="status-pill" aria-label={`${domain.repeticionesDeCerda(record.arete).length} repeticiones registradas: revisar historial`} title={domain.avisoRepeticiones(record.arete) || undefined}>⚠️ {domain.repeticionesDeCerda(record.arete).length} repeticiones</span>}</td>
          <td>{record.numPartos || 0}</td>
        </tr>)}</tbody>
      </ScrollTable>}
    </Card>}
  </>;
}
